import "./closestPolyfill"
import elementMatches from "./elementMatches"

const dropdownSelector = ".dropdown"
const dropdownToggleSelector = ".dropdown-toggle"
const dropdownMenuSelector = ".dropdown-menu"

document.addEventListener("click", (e) => {
  const dropdownToggle = elementMatches(e.target, dropdownToggleSelector)

  if (dropdownToggle) {
    e.preventDefault()
    e.stopPropagation()

    const dropdown = dropdownToggle.closest(dropdownSelector)
    const dropdownMenu = dropdown.querySelector(dropdownMenuSelector)

    dropdownMenu.classList.toggle("hidden")
    dropdownMenu.classList.toggle("block")
    // no need to check if click is outside dropdown elements
    return
  }

  const dropdownMenu = elementMatches(e.target, dropdownMenuSelector)
  if (!dropdownMenu) {
    // Click is outside the dropdown toggle and menu elements - hide
    // all dropdown menus.
    const dropdownMenus = document.querySelectorAll(dropdownMenuSelector)
    dropdownMenus.forEach((dropdownMenu) => {
      dropdownMenu.classList.replace("block", "hidden")
    })
  }
})
